import { gsap } from 'gsap'
import { useEffect, useRef } from 'react'

export const MCalculatorRingsGraphic = () => {
  const innerRingRef = useRef<SVGCircleElement>(null)
  const outerRingRef = useRef<SVGPathElement>(null)

  useEffect(() => {
    gsap.set([outerRingRef.current, innerRingRef.current], {
      transformOrigin: 'center center',
      scale: 1,
    })
    gsap.to(outerRingRef.current, {
      rotation: '360deg',
      ease: 'none',
      duration: 90,
      repeat: -1,
    })
  }, [])

  return (
    <svg
      className="absolute md:w-[30rem] md:h-[30rem] w-[20rem] h-[20rem]"
      viewBox="0 0 1286 1286"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="opacity-100"
        ref={outerRingRef}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1286 643.5h-22v-1h22v1zm-2.4-56l-21.9 1.8v-1l21.8-1.9.1 1zm-7.2-55.7l-21.7 3.8-.1-1 21.6-3.8.2 1zm-12-54.8l-21.3 5.7-.2-1 21.2-5.7.3 1zm-16.8-53.5l-20.7 7.5-.4-1 20.7-7.4.4.9zm-21.5-51.9l-20 9.3a36 36 0 01-.3-.8l19.9-9.4.4 1zm-25.9-49.7l-19 11-.5-.9 19-11 .5.9zm-30.2-47.3l-18 12.6a36 36 0 00-.5-.8l18-12.6.5.8zM1136 230l-16.9 14.1-.6-.7 16.9-14.2.6.8zm-37.9-41.4l-15.5 15.5-.7-.7 15.5-15.5.7.7zm-41.3-38l-14.2 16.9-.7-.6 14.1-16.9.8.6zm-44.5-34.2l-12.6 18-.8-.5 12.6-18 .9.5zM965 86.3l-11 19-.9-.4 11-19.1.9.5zm-49.7-26l-9.4 20-.8-.5 9.3-20 .9.5zm-51.9-21.5L856 59.5l-.9-.4 7.5-20.7 1 .4zm-53.4-17l-5.7 21.3-1-.2 5.7-21.3 1 .3zm-54.8-12l-3.8 21.6-1-.1 3.8-21.7 1 .2zm-55.6-7.3l-2 21.9h-.6l-.3-.1 1.9-22 1 .2zM643.5 0v22h-1V0a657.3 657.3 0 011 0zm-56 2.4h-1l1.8 22 1-.1-1.9-22zm-55.7 7.2l3.8 21.7-1 .1-3.8-21.6 1-.2zm-54.8 12l5.7 21.3-1 .2L476 22l1-.3zm-53.5 16.8l7.5 20.7-1 .4-7.4-20.7.9-.4zM371.6 60l9.3 20-.5.2-.3.1-9.4-19.9 1-.4zM322 85.8l11 19-.9.5-11-19 .9-.5zm-47.3 30.1l12.6 18-.8.6-12.6-18 .8-.6zM230 150.1l14.1 16.9-.7.6-14.2-16.9.8-.6zM188.7 188l15.5 15.5-.7.7-15.5-15.5.7-.7zm-38 41.3l16.9 14.2-.6.7-16.9-14.1.6-.8zm-34.2 44.5l18 12.6-.5.8-18-12.6.5-.8zM86.3 321l19 11-.4.9-19.1-11 .5-.9zm-26 49.7l20 9.4-.5.8-20-9.3.5-.9zm-21.5 51.9l20.7 7.5-.4.9-20.7-7.5.4-1zm-17 53.4l21.3 5.7-.2 1-21.3-5.7.3-1zm-12 54.8l21.6 3.8v.5l-.1.5-21.7-3.8.2-1zm-7.3 55.6l21.9 2-.1.9-22-1.9.2-1zM0 642.5a658.4 658.4 0 000 1h22v-1H0zm2.4 56v1l22-1.8v-.4l-.1-.6-22 1.9zm7.2 55.7l21.7-3.8.1 1-21.6 3.8-.2-1zm12 54.8l21.3-5.7.2 1L22 810l-.3-1zm16.8 53.5l20.7-7.5.4 1-20.7 7.4-.4-.9zM60 914.4l20-9.3c0 .3.2.5.3.8l-19.9 9.4-.4-1zM85.8 964l19-11 .5.9-19 11-.5-.9zm30.1 47.3l18-12.6.6.8-18 12.6-.6-.8zm34.2 44.5l16.9-14.1.6.7-16.9 14.2-.6-.8zm37.9 41.4l15.5-15.5.7.7-15.5 15.5-.7-.7zm41.3 38l14.2-16.9.7.6-14.1 16.9-.8-.6zm44.5 34.2l12.6-18 .8.5-12.6 18-.8-.5zm47.2 30.2l11-19 .9.5-11 19-.9-.5zm49.7 26l9.4-20 .8.5-9.3 20-.9-.5zm51.9 21.5l7.5-20.7.9.4-7.5 20.7-1-.4zm53.4 17l5.7-21.3 1 .2-5.7 21.3-1-.3zm54.8 12l3.8-21.6 1 .1-3.8 21.7-1-.2zm55.6 7.3l2-21.9.9.1-1.9 22-1-.2zm56.1 2.5v-22h1v22h-1zm56-2.4l-1.8-21.9h1l1.9 21.8-1 .1zm55.7-7.2l-3.8-21.7 1-.1 3.8 21.6-1 .2zm54.8-12l-5.7-21.3 1-.2 5.7 21.2-1 .3zm53.5-16.8l-7.5-20.7 1-.4 7.4 20.7-.9.4zm51.9-21.5l-9.3-20 .4-.1.4-.2 9.4 19.9-1 .4zm49.7-25.9l-11-19 .9-.5 11 19-.9.5zm47.3-30.2l-12.6-18 .8-.5 12.6 18-.8.5zm44.5-34.1l-14.1-16.9.7-.6 14.2 16.9-.8.6zm41.4-37.9l-15.5-15.5.7-.7 15.5 15.5-.7.7zm38-41.3l-16.9-14.2.6-.7 16.9 14.1-.6.8zm34.2-44.5l-18-12.6.5-.8 18 12.6-.5.9zm30.2-47.2l-19-11 .5-.9 19 11-.5.9zm26-49.7l-20-9.4.5-.8 20 9.3-.5.9zm21.5-51.9l-20.7-7.5.4-.9 20.7 7.5-.4 1zm17-53.4l-21.3-5.7.2-1 21.3 5.7-.3 1zm12-54.8l-21.6-3.8.1-1 21.7 3.8-.2 1zm7.3-55.6l-21.9-2 .1-.9 22 1.9-.2 1z"
        fill="#10A8BA"
        strokeWidth="4"
        strokeDasharray="2 4"
      />
      <circle
        className="opacity-100"
        ref={innerRingRef}
        cx="643"
        cy="643"
        r="571"
        stroke="#10A8BA"
        strokeWidth="4"
        strokeDasharray="2 4"
      />
    </svg>
  )
}
